import React, { useMemo } from "react";
import arrayMutators from "final-form-arrays";
import { Form } from "react-final-form";
import { useSelector } from "react-redux";

import { Dialog } from "../../../../../../../../../components/dialogs/Dialog/Dialog";
import { NormalizerField } from "../../../../../../../../../components/fields/NormalizerField";
import { FieldGroup } from "../../../../../../../../../components/forms/FieldGroup/FieldGroup";
import { Button, colorFirm } from "../../../../../../../../../components/Buttons/Button/Button";
import { normalizersSelector } from "../../../../../../../../../services/Normalizers/selectors";

import styles from "./styles.module.scss";

const NormalizerDialog = ({
    isOpen,
    onClose,
    initialValues,
    onSubmit
}) => {
    const { normalizers } = useSelector(normalizersSelector);

    const initFormValues = useMemo(
        () => {
            const newInitialValues = { ...initialValues };

            if(newInitialValues.options) {
                newInitialValues.options = JSON.parse(newInitialValues.options);
            }

            return newInitialValues;
        },
        [ initialValues ]
    );

    return (
        <Dialog
            classes={{ paper: styles.dialogPaper }}
            isOpen={isOpen}
            onClose={onClose}
            title="Data normalizer"
        >
            <Form
                onSubmit={onSubmit}
                initialValues={initFormValues}
                mutators={{ ...arrayMutators }}
                render={({ handleSubmit, values, form: { mutators: { push } } }) => (
                    <form onSubmit={handleSubmit}>
                        <div className={styles.formBody}>
                            <NormalizerField isMenuPortal/>

                            <div>
                                {
                                    normalizers && normalizers[values?.code] && (
                                        <>
                                            {
                                                normalizers[values.code]?.options_example && (
                                                    <div>
                                                        <b>Example:</b>&nbsp;{normalizers[values.code]?.options_example}
                                                    </div>
                                                )
                                            }

                                            {
                                                normalizers[values.code]?.description && (
                                                    <div>
                                                        <b>Description:</b>&nbsp;{normalizers[values.code]?.description}
                                                    </div>
                                                )
                                            }
                                        </>
                                    )
                                }
                            </div>

                            <div>
                                <FieldGroup
                                    nameGroup={"options"}
                                    label={"Options"}
                                    fieldsProps={[
                                        { nameField: "key", placeholder: "Key" },
                                        { nameField: "value", placeholder: "Value", isRequired: false }
                                    ]}
                                    withIndex={false}
                                    push={push}
                                />
                            </div>
                        </div>

                        <div className={styles.formBtns}>
                            <Button
                                colorFirm={colorFirm.firm2}
                                type={"submit"}
                            >
                                Save
                            </Button>

                            <Button
                                colorFirm={colorFirm.firm3}
                                onClick={onClose}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                )}
            />
        </Dialog>
    );
};

export default NormalizerDialog;
